import { PromotionalVideo } from '../../types/promotionalVideo';
import { PromotionalVideoState } from '../modules/promotionalVideo';

type StateWithPromotionalVideo = {
  promotionalVideo?: PromotionalVideoState;
};

export const getPromotionalVideo = (state: StateWithPromotionalVideo): PromotionalVideo | null =>
  state?.promotionalVideo?.data ?? null;

export const isLoading = (state: StateWithPromotionalVideo): boolean =>
  state?.promotionalVideo?.isLoading ?? false;

export const getError = (state: StateWithPromotionalVideo): string | null =>
  state?.promotionalVideo?.error ?? null;
